import ContactMainContent from "./ContactContent";

export default ContactMainContent;